// extracted by mini-css-extract-plugin
export default {"cls1":"_IrdQpwPJup2O6XTD8tr","cls2":"mVDtLWIyG5gwDl9XH28O _IrdQpwPJup2O6XTD8tr"};